import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    number: '',
    subject: '',
    nda: false,
    description: '',
});

const [successMessage, setSuccessMessage] = useState('');
const [errors, setErrors] = useState({});

const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
        ...formData,
        [name]: type === 'checkbox' ? checked : value,
    });
};

const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

const validatePhoneNumber = (number) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(number);
};


const validateForm = () => {
    let formErrors = {};
    if (!formData.name) formErrors.name = 'Name is required';
    if (!formData.email) {
        formErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
        formErrors.email = 'Email is not valid';
    }
    if (!formData.number) {
        formErrors.number = 'Phone number is required';
    } else if (!validatePhoneNumber(formData.number)) {
        formErrors.number = 'Phone number must be exactly 10 digits';
    }
    if (!formData.subject) formErrors.subject = 'subject is required';
    if (!formData.description) formErrors.description = 'Description is required';
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
};

const handleClick = async (e) => {
    e.preventDefault();  // Prevent default form submission

    if (!validateForm()) {
        return;
    }

    const data = {
        fields: [
            { name: 'name', value: formData.name },
            { name: 'email', value: formData.email },
            { name: 'phone', value: formData.number },
            { name: 'subject', value: formData.subject },
            { name: 'nda', value: formData.nda },
            { name: 'description', value: formData.description },
        ],
    };

    try {
        const response = await axios.post(
            'https://api.hsforms.com/submissions/v3/integration/submit/19706141/5bd8e860-cd73-49c1-b8c9-3c00c216bdc8',
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        console.log('Form submitted successfully:', response.data);

        // Clear form fields
        setFormData({
            name: '',
            email: '',
            number: '',
            budget: '',
            nda: false,
            description: '',
        });

        // Show success message
        setSuccessMessage('Form submitted successfully!');
        setErrors({});
    } catch (error) {
        console.error('Error submitting form:', error);
    }
};

  return (
    <div>
    <div className="subheader normal-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12 text-left">
            <h1 className="text-custom-white">Contact Us</h1>
            <ul className="custom-flex">
              <li className="fw-500"> <Link to="/" className="text-custom-white">Home</Link> </li>
              <li className="active fw-500"> Contact Us </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div className="section-padding contact-form-map">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-header style-left">
              <div className="section-heading">
                <h3 className="text-custom-black">Get In Touch</h3>
                <div className="section-description">
                  <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
                </div>
              </div>
            </div>
            {successMessage && (
                        <div className="alert alert-success mt-3 text-center" role="alert">
                            {successMessage}
                        </div>
                    )}
            <form className="mb-md-80 form_style style_two">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control form-control-custom" placeholder="Name" autoComplete='off' required/>
                    {errors.name && <span className="text-danger">{errors.name}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control form-control-custom" placeholder="Email I'd" autoComplete='off' required/>
                    {errors.email && <span className="text-danger">{errors.email}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input type="text" name="subject" value={formData.subject} onChange={handleChange} className="form-control form-control-custom" placeholder="Subject" autoComplete='off' required/>
                    {errors.subject && <span className="text-danger">{errors.subject}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input type="text" name="number" value={formData.number} onChange={handleChange} className="form-control form-control-custom" placeholder="Phone No." autoComplete='off' required/>
                    {errors.number && <span className="text-danger">{errors.number}</span>}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <textarea name="description" value={formData.description} onChange={handleChange} rows="5" className="form-control form-control-custom" placeholder="Message" autoComplete='off' required></textarea>
                    {errors.description && <span className="text-danger">{errors.description}</span>}
                  </div>
                  <button type="submit" className="btn-first btn-submit" onClick={handleClick}>Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Contact